export default __webpack_public_path__ + "static/media/on-hold.6eabc413.svg";